import { Pipe, PipeTransform } from '@angular/core';
import { LabelService } from '../services/label.service';

@Pipe({
  name: 'label',
  standalone: true,
})
export class LabelPipe implements PipeTransform {
  constructor(private labelService: LabelService) {}
  transform(key: string): string {
    return this.labelService.getLabel(key);
  }
}
